import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Logout } from '../components/axios';

export default function LogoutPage() {
	const navigate = useNavigate();

	useEffect(() => {
		Logout();
		navigate('/login');
	});

	return <div>Logging out...</div>;
}